import { ClassificationRateFormMode } from '../enums/classification-rate-form-mode.enum';

export const resolveFormMode = (
  path?: string
): ClassificationRateFormMode | null => {
  if (!path) return null;

  const pathMode: Record<string, ClassificationRateFormMode> = {
    'manage-master-wage-data/add': ClassificationRateFormMode.AddMasterWage,
    'classification-rate/edit':
      ClassificationRateFormMode.EditClassificationRate,
    'classification-rate/copy':
      ClassificationRateFormMode.CopyClassificationRate,
    'classification-rate/add': ClassificationRateFormMode.AddClassificationRate,
  };

  const match = Object.entries(pathMode).find(([key]) => path?.match(key));

  return match ? match[1] : null;
};
